import React, { useState } from "react";

function Ee(props) {
  const [ee, setEe] = useState();
  const error = "Votre score doit être entre 4 et 20";
  const [nclcEE, setNclcEE] = useState("");
  function handler(e) {
    setEe(e.target.value);
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    if (nclcEE !== error) {
      props.onSubmit(nclcEE);
    }
  };
  return (
    <div>
      <div className="Input">
        <span>Expression écrite :</span>
        <form className="row" onSubmit={handleSubmit}>
          <input
            className="Score"
            type={"number"}
            placeholder={"Saisissez votre score en EE.."}
            onChange={handler}
          />
          <button
            type="submit"
            className="ButtonNCLC"
            onClick={() => {
              if (ee >= 4 && ee <= 5) {
                setNclcEE(4);
              } else if (ee == 6) {
                setNclcEE(5);
              } else if (ee >= 7 && ee <= 9) {
                setNclcEE(6);
              } else if (ee >= 10 && ee <= 11) {
                setNclcEE(7);
              } else if (ee >= 12 && ee <= 13) {
                setNclcEE(8);
              } else if (ee >= 14 && ee <= 15) {
                setNclcEE(9);
              } else if (ee >= 16 && ee <= 20) {
                setNclcEE(10);
              } else {
                setNclcEE(error);
              }
            }}
          >
            NCLC
          </button>
          <h3 className="result">{nclcEE}</h3>
        </form>
      </div>
    </div>
  );
}

export default Ee;
